var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.828,
    viewBox: "0 0 16 16.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-left",
    transform: "translate(-4 -3.586)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x1: 14,
    transform: "translate(5 12)",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M12,19,5,12l7-7",
    fill: "none",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.646fc77e75923cec1148e613c20226cc.svg";
export { ForwardRef as ReactComponent };